import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@v/index')
      // redirect: '/banner',
      // children: [
      //   {
      //     path: '/banner',
      //     name: 'banner',
      //     component: () => import('@v/banner')
      //   },
      //   {
      //     path: '/haveDone',
      //     name: 'haveDone',
      //     component: () => import('@v/haveDone')
      //   },
      //   {
      //     path: '/powers',
      //     name: 'powers',
      //     component: () => import('@v/powers')
      //   },
      //   {
      //     path: '/news',
      //     name: 'news',
      //     component: () => import('@v/news')
      //   },
      //   {
      //     path: '/partner',
      //     name: 'partner',
      //     component: () => import('@v/partner')
      //   }
      // ]
    },
    {
      path: '/platformPower',
      name: 'platformPower',
      component: () => import('@v/platformPower')
    },
    {
      path: '/newDetail',
      name: 'newDetail',
      component: () => import('@v/newDetail')
    },
    {
      path: '/carOwner',
      name: 'carOwner',
      component: () => import('@v/carOwner')
    },
    {
      path: '/stationIntroduce',
      name: 'stationIntroduce',
      component: () => import('@v/stationIntroduce')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@v/aboutUs')
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('@v/join')
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('@v/map')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js